/*
 * 中华联合财险PARTNER_ID
 */
export const LHCXPARTNER_ID = 226
export const PERSONAL_ID = 14

// QQ地图API密钥
export const QQ_MAP_KEY = "VHSBZ-ZC7K3-ZSY3R-3EMIQ-MNRJH-7NBPL"

// 龙珠保单验证重定向配置
export const LONGZHU_REDIRECT_CONFIG = {
    PACKAGE_ID: '4607',
    PARTNER_ID: '293',
    SELECTED_SERVICES: '383'
};

// 判断是否需要进行龙珠验证重定向
export function shouldRedirectToLongzhu(packageParam, partnerIdParam) {
    return packageParam === LONGZHU_REDIRECT_CONFIG.PACKAGE_ID && 
           partnerIdParam === LONGZHU_REDIRECT_CONFIG.PARTNER_ID;
}



// WEBPACK FOOTER //
// ./src/common/js/constant.js